var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetaBaixoClicada(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 16.3,
    fill: "white",
    stroke: "white",
    strokeWidth: 1.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 17L17 23L11 17",
    stroke: "#1A3D00",
    strokeWidth: 1.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 11L17 17L11 11",
    stroke: "#1A3D00",
    strokeWidth: 1.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetaBaixoClicada);
export default __webpack_public_path__ + "static/media/setaBaixoClicada.3e45450dddd7317638de33abf89e00c5.svg";
export { ForwardRef as ReactComponent };